document.addEventListener('DOMContentLoaded', () => {
  const btnArea = document.querySelector('.m__fair__float__btn-area');
  let fairDescriptionReached = false;

  const btnAreaHeight = btnArea.offsetHeight;
  btnArea.style.top = `-${btnAreaHeight}px`;

  const fairDescription = document.querySelector('.js-fair-float-start');

  if (fairDescription) {
    const fairDescriptionRect = fairDescription.getBoundingClientRect();
    const scrollOffset = fairDescriptionRect.top+ window.scrollY;

    window.addEventListener('scroll', () => {
      const scrollTop = window.scrollY;
      const windowWidth = window.innerWidth;
      const isMobile = windowWidth < 768;

      if (!fairDescriptionReached && scrollTop >= scrollOffset) {
        btnArea.style.top = isMobile ? '85px' : '110px';
        fairDescriptionReached = true;
      } else if (fairDescriptionReached && scrollTop < scrollOffset) {
        btnArea.style.top = `-${btnAreaHeight}px`;
        fairDescriptionReached = false;
      }

      if (isMobile) {
        const elements = document.querySelectorAll('.sp-anchor-link a');
        elements.forEach(element => {
          element.textContent = element.textContent.replace(/<BR>/g, " ");
        });
      }
    });
  }
  const floatBannerArea = document.querySelector('.m__fair__float__banner-area');

  if (floatBannerArea) {
    const floatBannerHeight = floatBannerArea.offsetHeight;

    const currentPaddingBottom = parseFloat(window.getComputedStyle(document.querySelector('.m__footer__copyright')).paddingBottom);

    const newPaddingBottom = floatBannerHeight + currentPaddingBottom;
    document.querySelector('.m__footer__copyright').style.paddingBottom = newPaddingBottom + 'px';
  }
});
